// Import necessary modules
import React, { useEffect, useState } from 'react'
import { FaJs } from 'react-icons/fa'
import { FaChevronDown, FaCss3, FaHtml5 } from 'react-icons/fa6'
import { FcSettings } from 'react-icons/fc'
import SplitPane from 'react-split-pane'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../Image/logo.webp';
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from '@codemirror/lang-javascript';
import { Hidden } from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import { MdCheck, MdEdit } from 'react-icons/md'
import { signOut } from "firebase/auth";
import { auth } from '../firebase';
import { setDoc, doc } from 'firebase/firestore'
import { db } from "../firebase"
import Alert from './Alert'

function NewProject({ setIsLoggedIn, setUser, user }) {

  const [html, sethtml] = useState("")
  const [css, setcss] = useState("")
  const [js, setjs] = useState("")
  const [output, setoutput] = useState("")
  const [title, settitle] = useState("Untitled")
  const [istitle, setistitle] = useState("");
  const [alert, setalert] = useState(false);
  useEffect(() => {
    updateoutput()
  }, [html, css, js])

  const updateoutput = () => {
    const combinedoutput =
      `<html>
        <head>
        <style>${css}</style>
        </head>
        <body>
        ${html}
        <script>${js}</script>
        </body>
      </html>
      `;
    setoutput(combinedoutput);
  }

  const navigate = useNavigate();
  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        setUser(null);
        setIsLoggedIn(false);
        navigate("/home/signup");
        console.log("Signed out successfully");
      })
      .catch((error) => {
        // Handle error
      });
  };


  const saveprogram = async () => {
    const id = `${Date.now()}`
    const _doc = {
      id: id,
      html: html,
      css: css,
      js: js,
      title: title,
      output: output,
      user: {
        uid:user.uid,
        displayName: user.displayName,
        email: user.email,
        // Add other necessary fields if needed
      }
    }

    await setDoc(doc(db, "Projects", id), _doc).then((res) => { setalert(true) }).catch((err) => console.log(err));

    setInterval(() => {
      setalert(false)
    }, 2000);
  }

  

  return (
    <>
      <div className="w-screen h-screen flex flex-col items-start justify-start overflow-hidden">

        {/*alert section*/}
        <AnimatePresence>
          {alert && <Alert status={"Success"} alertmsg={"Project Saved !"} />}
        </AnimatePresence>
        {/*header section*/}

        <header className='w-full flex items-center justify-between px-12 py-4'>
          <div className="flex items-start justify-center gap-6">
            <Link to={'/home/projects'}><img src={logo} alt="Logo" className="object-contain w-32 h-auto mt-3" />
            </Link>
            <div className="flex flex-col items-start justify-start">
              {/*title*/}
              <div className="flex  items-center justify-center gap-3">
                <AnimatePresence>
                  {istitle ? (<>
                    <motion.input key={"titleinput"}
                      type="text"
                      placeholder="Your Title"
                      className='px-3 py-2 rounded-md bg-transparent text-primaryText text-base
                        outline-none border-none'
                      value={title}
                      onChange={(e) => settitle(e.target.value)}
                    />
                  </>) :
                    (<>
                      <motion.p
                        key={"titlelabel"}
                        className='px-3 py-2 text-white text-lg'>
                        {title}
                      </motion.p>
                    </>)}
                </AnimatePresence>

                <AnimatePresence>
                  {istitle ? (<>
                    <motion.div key={"MdCheck"}
                      whileTap={{ scale: 0.9 }}
                      className='cursor-pointer'
                      onClick={() => setistitle(false)}
                    >
                      <MdCheck className='text-2xl text-emerald-500' />
                    </motion.div>
                  </>) :
                    (<>
                      <motion.div
                        key={"MdEdit"}
                        whileTap={{ scale: 0.9 }}
                        className='cursor-pointer'
                        onClick={() => setistitle(true)}
                      >
                        <MdEdit className='text-2xl text-primaryText' />
                      </motion.div>
                    </>)}
                </AnimatePresence>

              </div>

              {/*follow*/}

              <div className="flex items-center justify-center px-3 mt-2 gap-2">

                {user && (
                  <p className="text-primaryText text-sm">{user.displayName}</p>
                )}

                <motion.p
                  whileTap={{ scale: 0.9 }}
                  className='text-[10px] bg-emerald-500 rounded-sm px-2 py-[1px] text-primary font-semibold
                cursor-pointer'>
                  + Follow
                </motion.p>
              </div>
            </div>
          </div>

          {/*user section*/}

          {user && (
            <>
              <div className="flex items-center justify-center gap-4">
                <motion.button onClick={saveprogram} whileTap={{ scale: 0.9 }} className='px-5 py-2 bg-primaryText cursor-pointer text-base text-primary font-semibold rounded-md'>
                  Save
                </motion.button>

                <Link  to={'/home/userwork'} className='flex items-center justify-center gap-6 text-gray-400'>
                  <p className='w-14 bg-emerald-400 py-2 px-1 text-center text-white rounded-xl text-2xl hover:bg-emerald-700 cursor-pointer capitalize'>
                    {user.email[0]}</p>
                </Link>
                <div className='flex items-center justify-center gap-6 text-gray-400' onClick={handleLogout}>
                  <p className='w-24 bg-secondary py-3 px-4 text-center text-white rounded-md text-lg hover:bg-emerald-700 cursor-pointer'>Logout</p>
                </div>
              </div>
            </>)}
        </header>

        {/*coding section*/}
        <div>
          <SplitPane split="horizontal" miniSize={100} maxSize={-100} defaultSize={"50%"}>
            <SplitPane split='vertical' minSize={500}>
              {/*HTML CODE*/}
              <div className="w-full h-full flex flex-col items-start justify-start">
                <div className="w-full flex items-center justify-between">
                  <div className="bg-secondary px-4 py-2 border-t-4 flex items-center justify-center gap-3 border-t-gray-500">
                    <FaHtml5 className='text-xl text-red-500' />
                    <p className='text-primaryText font-semibold '>HTML</p>
                  </div>

                  <div className="cursor-pointer flex items-center justify-center px-4 gap-5">
                    <FcSettings className='text-xl' />
                    <FaChevronDown className='text-xl text-primaryText' />
                  </div>
                </div>
                <div className="bg-primary w-full h-full rounded-md overflow-hidden" style={{ overflow: "Hidden", height: "100%" }}>
                  <CodeMirror  style={{ border: "none", width: "100%", height: "100%", overflow:"auto" }}
                    value={html}
                    
                    extensions={[javascript({ jsx: true })]}
                    theme={"dark"}
                    onChange={(value, viewupdate) => {
                      sethtml(value)
                    }}
                  />
                </div>
              </div>
              <SplitPane split='vertical' minSize={500}>
                {/* CSS CODE */}
                <div className="w-full h-full flex flex-col items-start justify-start">
                  <div className="w-full flex items-center justify-between">
                    <div className="bg-secondary px-4 py-2 border-t-4 flex items-center justify-center gap-3 border-t-gray-500">
                      <FaCss3 className='text-xl text-sky-500' />
                      <p className='text-primaryText font-semibold '>CSS</p>
                    </div>

                    <div className="cursor-pointer flex items-center justify-center px-4 gap-5">
                      <FcSettings className='text-xl' />
                      <FaChevronDown className='text-xl text-primaryText' />
                    </div>
                  </div>
                  <div className="bg-primary w-full h-full rounded-md overflow-hidden" style={{ overflow: "Hidden", height: "100%" }}>
                    <CodeMirror style={{ border: "none", width: "100%", height: "100%", overflow:"auto" }}
                      value={css}
                      
                      extensions={[javascript({ jsx: true })]}
                      theme={"dark"}
                      onChange={(value, viewupdate) => {
                        setcss(value)
                      }}
                    />
                  </div>
                </div>

                {/* JS CODE */}
                <div className="w-full h-full flex flex-col items-start justify-start">
                  <div className="w-full flex items-center justify-between">
                    <div className="bg-secondary px-4 py-2 border-t-4 flex items-center justify-center gap-3 border-t-gray-500">
                      <FaJs className='text-xl text-yellow-500' />
                      <p className='text-primaryText font-semibold '>JS</p>
                    </div>

                    <div className="cursor-pointer flex items-center justify-center px-4 gap-5">
                      <FcSettings className='text-xl' />
                      <FaChevronDown className='text-xl text-primaryText' />
                    </div>
                  </div>
                  <div className="bg-primary w-full h-full rounded-md overflow-hidden" style={{ overflow: "Hidden", height: "100%" }}>
                    <CodeMirror style={{ border: "none", width: "100%", height: "100%", overflow:"auto" }}
                      value={js}
                      
                      extensions={[javascript({ jsx: true })]}
                      theme={"dark"}
                      onChange={(value, viewupdate) => {
                        setjs(value)
                      }}
                    />
                  </div>
                </div>
              </SplitPane>
            </SplitPane>

            {/*bottom result*/}
            <div className="bg-white" style={{ overflow: "Hidden", height: "100%" }}>
              <iframe
                title='Result'
                srcDoc={output}
                style={{ border: "none", width: "100%", height: "100%" }}
              />
            </div>
          </SplitPane>
        </div>
      </div>
    </>
  )
}

export default NewProject






